import { ICalendarEvent } from "motw_core/Calendar/ICalendarEvent";
import { ECalendarName } from "../../../../../../../../motw_core/Calendar/ECalendarName";
import { calendarEvent_freeTime } from "motw_core/Constants/constants";


export function GetNewCalendarEvent(startTime: string, endTime: string) {
    const calendarEvent: ICalendarEvent = {
        name: calendarEvent_freeTime,
        start: startTime,
        end: endTime,
        calendar: ECalendarName[ECalendarName.Free],
        id: "",
        isCompleted: false,
        etag: ``,
        isRepeating: false,
        completionEventId: "",
        isExpired: false,
        icalData: "",
        firstRecurrenceDate: "",
    };

    return calendarEvent;
}
